export function getFlag (countryCode) {
  countryCode = countryCode.toUpperCase()
  return typeof String.fromCodePoint === 'function'
    ? String.fromCodePoint(...[...countryCode].map(c => c.charCodeAt() + 0x1f1a5))
    : [...countryCode]
      .map(c => '\ud83c' + String.fromCharCode(0xdda5 + c.charCodeAt()))
      .join('')
}
